<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/woreportrecord/page"
        getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')">
            <el-input disabled v-model="$attrs.reportWork.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shebeimingcheng')">
            <yi_cross_select disabled multiple :component="'web_base_equipment_list'"
                :ids.sync="$attrs.reportWork.equipmentId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('mujubianma/mingcheng')">
            <yi_cross_select disabled multiple :selectTitle="'code,name'" :component="'web_base_mould_list'" :max="1"
                :ids.sync="$attrs.reportWork.mouldId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
            <yi_cross_select disabled multiple :selectTitle="'code,name'"
                :component="'web_base_matter_list'" :ids.sync="$attrs.reportWork.materialId">
            </yi_cross_select>
          </el-form-item>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>
      <template #top2>
        <div style="width:calc(100% + 50px);margin-left: -50px;">
          <div style="width: 100%;" :style="{ height: chartHeight + 'px' }" :id="'web_production_management_work_order_execution_report_list'">
          </div>

        </div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #shifoubulu="scope">
        {{scope.row.type == 0 ? $t('fou') : $t('shi')}}
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('baogongjilu', scope.row,'w2')">
              {{$t('baogongjilu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>

</template>
<script type="text/javascript">
// import work_bom from '@@/pages/web/order_management/erp/work_bom'
export default {
  props: ['chart'],
  name: 'web_production_management_work_order_execution_report',
  components: {
    // work_bom
  },
  data() {
    return {
      chartHeight: '',
      status: {

        "1": {
          color: 'rgba(65, 159, 255, 1)',
          title: this.$t('xinjian'),
          tagBg: 'rgba(65, 159, 255, 0.2)',
          cardBg: 'linear-gradient(180deg, #2686E9 0%, rgba(18, 18, 18, 0) 100%)',
        },
        "2": {
          color: 'rgba(65, 159, 255, 1)',
          title: this.$t('fafang'),
          tagBg: 'rgba(65, 159, 255, 0.2)',
          cardBg: 'linear-gradient(180deg, #2686E9 0%, rgba(18, 18, 18, 0) 100%)',
        },
        "3": {
          color: '#A4DA89',
          title: this.$t('shengchanzhong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)',
        },
        "4": {
          color: 'rgba(255, 58, 94, 1)',
          title: this.$t('zanting'),
          tagBg: 'rgba(255, 58, 94, 0.2)',
          cardBg: 'linear-gradient(180deg, #FF3A5E 0%, rgba(18, 18, 18, 0) 100%)',
        },
        "5": {
          color: '#A4DA89',
          title: this.$t('shougongxuwangong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)',
        },
        "6": {
          color: '#39F16D',
          title: this.$t('wangong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)',
        },
        "7": {
          color: 'rgba(153, 160, 173, 1)',
          title: this.$t('guanbi'),
          tagBg: 'rgba(153, 160, 173, 0.2)',
          cardBg: 'linear-gradient(180deg, #A5A5A5 0%, rgba(18, 18, 18, 0) 100%)',
        },
        "8": {
          color: 'rgba(255, 200, 58, 1)',
          title: this.$t('yidiaobo'),
          tagBg: 'rgba(255, 200, 58, 0.2)',
          cardBg: 'linear-gradient(180deg, #FA9D2D 0%, rgba(18, 18, 18, 0) 100%)',
        },
      },
      woIds: '',
      showMode: 'list',
      progresses: [],
      gridFlowHeights: {},
      editConditions: {
        priority: ''
      },
      drawer: false,
      direction: 'btt',
      addDrawer: false,
      updateDrawer: false,
      graph: null,
      currentNode: null,
      selectParentIds: null,
      priority: null,
      routeList: [],
      nodeList: [],
      flows: [],
      currentNodeId: null,
      columns: [{
        label: 'gongxumiaoshu',
        prop: 'procedureDesc',
        width: 130
      }, {
        label: 'baogongshuliang',
        prop: 'quantity',
        width: 130
      }, {
        label: 'buliangshuliang',
        prop: 'badQuantity',
      },
        {
          label: 'jiqijilushuliang',
          prop: 'machineQuantity',
          width: 150,
        },
        {
          label: 'chayishuliang',
          prop: 'diffQuantity',
          width: 150,
        }, {
          label: 'baogongriqi',
          prop: 'reportDate',
          format: "YYYY-MM-DD",
          type: 'time',
          width: 150,
        }, {
          label: 'baogongbanci',
          prop: 'shiftName',
          width: 150,
        }, {
          label: 'tibaoshijian',
          prop: 'createTime',
          type: 'time',
          width: 150,
        }, {
          label: 'jiqijilukaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 150,
        }, {
          label: 'jiqijilujieshushijian',
          prop: 'endTime',
          type: 'time',
          width: 150,
        }, {
          label: 'caozuoren',
          prop: 'createByObject.nickname',
          // width: 150,
        }, {
          label: 'shifoubulu',
          prop: 'type',
          type: 'slot'
          // width: 150,
        }, {
          label: 'beizhu',
          prop: 'remark',
        }
      ]
    };
  },
  mounted() {
    let woProcedureId = this.$attrs.reportWork.woProcedureList
    for(let i =0;i<woProcedureId.length; i++) {
      this.woIds = woProcedureId[i]['id']
      console.log('woProcedureId',this.woIds)
    }
    this.progresses = this.chart
    this.$nextTick(() => {
      this.initPie(this.showMode)
    })
  },
  created() {
    this.utils.event_hub.$on('node5Tap', this.node5Tap);
    setTimeout(() => {

      this.yt.conditions = {

        // woProcedureId: this.woIds,
        woId:this.$attrs.reportWork.id
        // orderBy: 'planStartTime,equipmentId asc',
      }
      this.yt.get(1)
    }, 300)
  },
  methods: {
    initPie(listOrGrid) {
      // console.log('this.progresses.woProcedureList', this.progresses)
      let woProcedureList = this.progresses.woProcedureList
      let nodes = woProcedureList.map(item => {
        return {
          id: item.routeWorkProcedureId + "",
          shape: "node5",
          width: 83,
          height: 60,
          data: {
            id: 'web_production_management_work_order_execution_report_' + listOrGrid + '_' + item
                .routeWorkProcedureId,
            color: this.status[this.progresses.status].color,
            title: item.procedureDesc,
            percent: (item.finishGoodQuantity) / (item.planQuantity)
          },
        }
      })
      // console.log('nodes', nodes)

      let edges = []
      for (var j = 0; j < woProcedureList.length; j++) {
        let node = woProcedureList[j]
        if (woProcedureList[j].parentIds == "") {
          continue
        }
        let parentIdArr = woProcedureList[j].parentIds.split(",")
        for (var k = 0; k < parentIdArr.length; k++) {
          edges.push({
            attrs: {
              line: {

                targetMarker: {
                  tagName: 'circle',
                  r: 2,
                  cx: 2,
                  fill: '#C0C4CC',
                  stroke: '#C0C4CC',
                },
                stroke: '#606672',
                strokeWidth: 1,
              },
            },
            source: parentIdArr[k],
            target: node.routeWorkProcedureId + "",
            router: {
              name: 'manhattan',
              startDirections: ['right'],
              endDirections: ['left'],
            },
          })
        }
      }



      this.initFlow('web_production_management_work_order_execution_report_' + listOrGrid, nodes, edges)

      this.countFlowHeihgt(listOrGrid)
    },
    countFlowHeihgt(listOrGrid) {
      if (!listOrGrid) {
        listOrGrid = this.showMode
      }
      setTimeout(() => {
        this.chartHeight = document.getElementById('web_production_management_work_order_execution_report_list').getElementsByClassName(
            'x6-graph-svg-viewport')[0].getBoundingClientRect().height + 40
      }, 600)
    },
    node5Tap(params) {
      this.currentNode = params.item
      console.log('params', params)
      console.log('params11', this.currentNode.parentIds)
      const nodes = this.graph.getNodes();
      if (nodes.length) {
        nodes.forEach((node) => {
          node.setData({
            currentNodeId: this.currentNode.id,
          });
        });
      }
      this.currentNodeId = this.currentNode.id
    },
    initFlow(id, nodes, edges) {
      this.graph = new this.x6({
        container: document.getElementById(id),
        width: 'auto',
        height: 'auto',
        grid: false,
        interacting: {
          nodeMovable: false
        },
      });
      const model = {
        nodes: nodes,
        edges: edges,
      }
      const dagreLayout = new this.x6layout({
        type: 'dagre',
        rankdir: 'LR',
        align: 'UL',
        // rankdir: 'TB',
        // align: 'DR',
        ranksep: 25,
        nodesep: 10,
        controlPoints: true,
      })
      const newModel = dagreLayout.layout(model)
      this.graph.fromJSON(newModel)
    },
    getNodeList() {
      this.http.get('/web/craft/basic/work/procedure/page', {
        params: {
          pageNum: 1,
          pageSize: 10
        }
      }).then(res => {
        this.nodeList = res.data.rows
        let workName = ''
        for (let i = 0; i < this.nodeList.length; i++) {
          this.nodeList[i].workName = this.nodeList[i]['code'] + '/' + this.nodeList[i]['desc']
        }
        // console.log('lll', this.nodeList)
      })

    }
  }
};
</script>
